import { useState } from 'react';
import TopBar from '../components/TopBar.jsx';
import { useTheme } from '../context/ThemeContext';
import Footer from '../components/Footer';

function About() {
  const [visibleSection, setVisibleSection] = useState(null);
  const [toggle, setToggle] = useState(true);
  const { theme } = useTheme();

  const toggleVisibility = section => {
    setVisibleSection(visibleSection === section ? null : section);
  };

  return (
    <div className="flex flex-col min-h-screen" style={{ background: 'var(--page-bg)' }}>
      <TopBar />
      <div className="flex-grow pt-24 pb-12 px-4 sm:px-8 md:px-16 lg:px-24 max-w-7xl mx-auto mt-2">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          {/* Left Column - Introduction */}
          <div className="flex-1">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: 'var(--text-primary)' }}>
              We are here to answer your questions
            </h1>
            <div className="rounded-xl overflow-hidden mb-8 shadow-lg p-4" style={{ background: 'var(--header-bg)' }}>
              <img
                src={theme === 'light' ? "/img/logo-light.png" : "/img/logo-dark.png"}
                alt="FAQ Banner"
                className="max-h-[120px] mx-auto"
              />
            </div>
            <div className="mb-8 text-center">
              <p className="text-lg mb-4" style={{ color: 'var(--text-secondary)' }}>
                Here are answers to common questions about LoadingCoin.
                Still can't find what you need? Contact us for guidance!
              </p>
              <a
                href="https://t.me/LoadingCoin"
                target="_blank"
                rel="noreferrer"
                className="inline-block px-6 py-3 rounded-lg font-medium transition-all"
                style={{
                  background: 'var(--primary-gradient)',
                  color: 'var(--button-text)',
                  boxShadow: 'var(--shadow)',
                }}
              >
                Chat with us now!
              </a>
            </div>
          </div>

          {/* Right Column - FAQ Content */}
          <div className="flex-1 max-w-2xl">
            {/* Toggle Buttons */}
            <div className="flex justify-center mb-8 gap-4">
              <button
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  toggle ? 'text-white' : 'text-gray-400'
                }`}
                onClick={() => setToggle(true)}
                style={{
                  background: toggle ? 'var(--primary-gradient)' : 'var(--button-secondary-bg)',
                  border: toggle ? 'none' : '2px solid var(--button-secondary-border)',
                  color: toggle ? 'var(--button-text)' : 'var(--button-secondary-text)',
                }}
              >
                Investors
              </button>
              <button
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  !toggle ? 'text-white' : 'text-gray-400'
                }`}
                onClick={() => setToggle(false)}
                style={{
                  background: !toggle ? 'var(--primary-gradient)' : 'var(--button-secondary-bg)',
                  border: !toggle ? 'none' : '2px solid var(--button-secondary-border)',
                  color: !toggle ? 'var(--button-text)' : 'var(--button-secondary-text)',
                }}
              >
                Developers
              </button>
            </div>

            {/* FAQ Items */}
            <div className="space-y-4">
              {toggle ? (
                // Investors FAQs
                <>
                  {[
                    {
                      id: 6,
                      question: "What is LoadingCoin?",
                      answer:
                        "LoadingCoin is your go-to platform for launching tokens without all the hassle! It's built to make token deployment easy and fast, while giving investors a sneak peek into the hottest, most secure crypto projects before they take off.",
                    },
                    {
                      id: 7,
                      question: "How does LoadingCoin make life sweeter for investors?",
                      answer:
                        "It gives you an insider pass to brand-new tokens before they hit the big DEX stages! This means you get a chance to scoop up tokens early, boosting your potential for major returns while keeping things secure.",
                    },
                    {
                      id: 8,
                      question: "Is investing in LoadingCoin safe?",
                      answer:
                        "Absolutely! LoadingCoin takes the guesswork out of safety by managing both the liquidity pool and token contract. This creates a far more secure environment than the wild, scam-filled markets you're used to.",
                    },
                    {
                      id: 9,
                      question: "How can I start investing on LoadingCoin?",
                      answer:
                        "Getting started is super simple! Just connect your wallet, and you're all set. Browse through a variety of exciting projects right on our homepage.",
                    },
                    {
                      id: 11,
                      question: "What happens when a token reaches a $69,000 market cap?",
                      answer:
                        "When a token hits the $69,000 market cap milestone, it's automatically listed on a DEX with $13,800 in liquidity. Plus, to boost safety, the LP tokens are burned, and the contract is renounced.",
                    },
                    {
                      id: 12,
                      question: "Are there other ways to earn money through LoadingCoin?",
                      answer:
                        "Yes, absolutely! You don't need to invest money to start earning. Launch your project or refer friends to earn 50% of the fees.",
                    },
                  ].map((item) => (
                    <div key={item.id} className="rounded-xl">
                      <div
                        className="p-5 cursor-pointer flex justify-between items-center rounded-t-xl"
                        onClick={() => toggleVisibility(item.id)}
                        style={{
                          background: 'var(--card-bg)',
                          border: '2px solid transparent',
                          backgroundImage:
                            'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                          backgroundOrigin: 'border-box',
                          backgroundClip: 'padding-box, border-box',
                        }}
                      >
                        <h3 className="font-medium text-lg" style={{ color: 'var(--text-primary)' }}>
                          {item.question}
                        </h3>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          className={`transition-transform duration-200 ${
                            visibleSection === item.id ? 'rotate-180' : ''
                          }`}
                          style={{ color: 'var(--text-primary)' }}
                        >
                          <path d="m6 9 6 6 6-6"></path>
                        </svg>
                      </div>

                      {visibleSection === item.id && (
                        <div
                          className="p-5"
                          style={{
                            background: 'var(--section-bg)',
                            color: 'var(--text-secondary)',
                          }}
                        >
                          <p>{item.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </>
              ) : (
                // Developers FAQs
                <>
                  {[
                    {
                      id: 0,
                      question: "How does LoadingCoin benefit developers?",
                      answer:
                        "LoadingCoin streamlines the token deployment process, making it fast, easy, and affordable. In just a minute, you can launch your token and instantly reach thousands of potential investors.",
                    },
                    {
                      id: 1,
                      question: "Which coding skills do I need to deploy a token?",
                      answer:
                        "None! You don't need any coding experience. All you have to do is fill out a few details and pay the deployment transaction fee.",
                    },
                    {
                      id: 2,
                      question: "How much does it cost to launch a project with LoadingCoin?",
                      answer:
                        "The BASIC launch costs only around $2 to $3 plus gas fees. The FEATURED OPTION is about $250 for top visibility and marketing.",
                    },
                    {
                      id: 3,
                      question: "How can I start investing in LoadingCoin?",
                      answer:
                        "Just connect your wallet! Explore various projects on our homepage, where you can easily filter options to find the perfect investment.",
                    },
                    {
                      id: 4,
                      question: "Are there trading fees on LoadingCoin?",
                      answer:
                        "Yes! There's a small 1% fee on every trade. You can earn 50% of those fees by sharing your referral link.",
                    },
                    {
                      id: 5,
                      question: "Are there other ways to earn money through LoadingCoin?",
                      answer:
                        "Refer your friends and earn 50% of the fees on every trade they make. Just grab your referral link from any token page.",
                    },
                  ].map((item) => (
                    <div key={item.id} className="rounded-xl">
                      <div
                        className="p-5 cursor-pointer flex justify-between items-center rounded-t-xl"
                        onClick={() => toggleVisibility(item.id)}
                        style={{
                          background: 'var(--card-bg)',
                          border: '2px solid transparent',
                          backgroundImage:
                            'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                          backgroundOrigin: 'border-box',
                          backgroundClip: 'padding-box, border-box',
                        }}
                      >
                        <h3 className="font-medium text-lg" style={{ color: 'var(--text-primary)' }}>
                          {item.question}
                        </h3>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          className={`transition-transform duration-200 ${
                            visibleSection === item.id ? 'rotate-180' : ''
                          }`}
                          style={{ color: 'var(--text-primary)' }}
                        >
                          <path d="m6 9 6 6 6-6"></path>
                        </svg>
                      </div>

                      {visibleSection === item.id && (
                        <div
                          className="p-5"
                          style={{
                            background: 'var(--section-bg)',
                            color: 'var(--text-secondary)',
                          }}
                        >
                          <p>{item.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default About;
